import styled from 'styled-components';

export const TableCellContainer = styled.td`
  flex: 1;
  display: flex;
  padding: 0;
`;
